import styled from 'styled-components';

const StyledSampleItemToolbar = styled.section`
	position: relative;
	& > section {
		display: flex;
	}
    .filterWrapper {
        margin-left: var(--spacing-large);
    }
	.FirstRow {
		display: flex;
		align-items: center;
		.motif-dropdown-menu {
			&[x-placement^='bottom-end']:before {
				left: unset;
				right: 58%;
			}
		}
		> button {
			border-radius: 0;
			min-height: var(--px-40);
			border-color: var(--neutrals-900);
			&:hover {
				svg[name='filter'] {
					fill: var(--neutrals-00white);
				}
			}
			svg[name='filter'] {
				fill: var(--neutrals-900);
			}
		}

		.clearButton {
			min-height: unset !important;
		}
	}

	.FilterControlsWrapper {
		flex-wrap: wrap;
		padding: 0;
		button {
			min-width: var(--px-120);
			max-width: var(--px-180);
			box-shadow: none;
            margin-left: 0;
			margin-right: var(--px-8);
			&.motif-button-primary-alt {
				height: var(--px-44);
				font-size: var(--px-14);
				min-width: var(--px-88);
				padding: var(--px-8) !important;
			}
		}
		.motif-dropdown {
			margin-top: calc(var(--px-1) * -1);
			button {
				margin-right: 0;
				&.motif-dropdown-item {
					max-width: 100%;
					&:hover {
						border-color: var(--neutrals-200);
						.ClearIcon {
							svg {
								path {
									fill: var(--neutrals-900);
								}
							}
						}
					}
				}
				.clearButton {
					min-height: unset !important;
				}
			}
			.MotifDropdownItemContainer {
				min-height: var(--px-45);
				.ClearIcon {
					right: calc(var(--px-5) * -1);
				}
				button.motif-dropdown-item {
					max-width: 100%;
				}
			}
		}
	}
	button {
		&.FilterButtonWrapper {
			width: var(--px-100);
			@media only screen and (min-width: 1366px) {
				width: var(--px-120);
			}
			.filter-button-type,
			.filter-button-ellipses {
				width: 85%;
			}
			.ClearIcon {
				right: var(--px-1);
			}
			.filter-button-date {
				text-align: left;
			}
		}
	}
	.clearButton {
		min-height: unset !important;
	}
`;
export default StyledSampleItemToolbar;